export default __webpack_public_path__ + "static/media/calendar.550eebd3.svg";